import React, { Component } from "react";
import { Navigate } from "react-router";
import { connect } from "react-redux";
import * as auth from "../_redux/authRedux";
import { LayoutSplashScreen } from "../../../../_metronic/layout";

class Logout extends Component {
  componentDidMount() {
    this.props.logout();
  }

  render() {
    localStorage.removeItem("test");
    const { hasAuthToken } = this.props;
    return hasAuthToken ? (
      <LayoutSplashScreen />
    ) : (
      <Navigate to="/auth/login" replace />
    );
  }
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
  auth.actions
)(Logout);
